import styled from 'styled-components';
import LegalInfo from 'components/summary/LegalInfo/container';

export default styled(LegalInfo)`
  color: var(--grey700);
  a {
    color: var(--primary500);
    &:hover {
      color: var(--primary500);
    }
  }
  .summary-legal-link {
    display: inline;
  }
`;
